<template>
  <div class="card">
    <p class="header">
      {{ title }}
    </p>
    <p class="content" :class="{ bold, clickable }" @click="valueClicked">
      {{ value }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    valueClicked() {
      if (this.clickable) {
        this.$emit('clicked');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.card {
  margin-top: $space-6;
  min-width: 176px;
  flex-grow: 1;

  .bold {
    font-weight: bold;
  }

  .content.clickable {
    cursor: pointer;
    color: var(--status-info);
    font-size: $font-size-md;
    font-weight: 500;
    letter-spacing: 0;
    line-height: $space-5;
  }

  .header {
    color: var(--text-tertiary);
    text-transform: uppercase;
    font-size: $font-size-xs;
    letter-spacing: 0.8px;
    line-height: $font-size-xs;
    margin-bottom: $space-2;
    height: $font-size-xs;
  }

  .content {
    color: var(--text-primary);
    font-size: $font-size-md;
    letter-spacing: 0;
    line-height: $space-5;
    margin-bottom: 0px;
    padding-right: $space-5;
    height: $space-5;
  }
}
</style>
